// Must run before any React/app code so Date.prototype is patched everywhere
import "@/utils/timezonePatch";

import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { isChunkError, recoverFromChunkError } from "@/utils/chunkErrorRecovery";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register minimal error-intercepting service worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}

// Global unhandled promise rejection handler — prevents silent failures
window.addEventListener('unhandledrejection', (event) => {
  const error = event.reason;
  if (isChunkError(error)) {
    event.preventDefault();
    recoverFromChunkError();
    return;
  }
  // Log but don't crash for other unhandled rejections
  console.error('[Unhandled Rejection]', error);
});

// Some chunk errors surface as a synchronous `error` event (e.g. when a
// <link rel="stylesheet"> for a missing CSS chunk fails to load). Treat
// the same way.
window.addEventListener('error', (event) => {
  if (isChunkError(event.error || event)) {
    event.preventDefault?.();
    recoverFromChunkError();
  }
});
